import { Component, EventEmitter, Input, OnChanges, Optional, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Logger } from '@df/core/service/logger';
import { FormFieldModel } from '../../field-abstract/form-field.model';

@Component({
    selector: 'radio-group',
    templateUrl: 'radio-group.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class RadioGroupComponent<T = any> implements OnChanges {
    @Input({
        required: true
    })
    model?: T;

    @Input({
        required: true
    })
    name?: string;

    @Input()
    required = false;

    @Output()
    modelChange = new EventEmitter<T>();

    constructor(
        private logger: Logger,
        @Optional() private formFieldModel?: FormFieldModel
    ) {}

    onModelChange() {
        this.modelChange.emit(this.model);
    }

    ngOnChanges(changes) {
        if (changes.required) {
            this.formFieldModel?.notifyParamsChange();
        }
    }
}
